exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.news-content[data-v-26375fbd] {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.scrolling-text[data-v-26375fbd] {\n  display: inline-block;\n  white-space: nowrap;\n}\n", ""]);

// exports
